import * as React from "react";
const SvgFiRrLimitSpeedometer = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-limit-speedometer_svg__a)">
      <path
        fill="#062147"
        d="M12 14a2 2 0 0 1-2-2c0-.178.031-.348.074-.512l-3.78-3.781a.999.999 0 1 1 1.413-1.414l3.781 3.78c.164-.043.334-.073.512-.073a2 2 0 1 1 0 4m7.996-10.948A12.06 12.06 0 0 0 10.617.077C5.208.685.785 5.04.1 10.437c-.477 3.758.783 7.432 3.456 10.079.576.57 1.34.858 2.104.858a3 3 0 0 0 1.97-.73l1.025-.887a1.001 1.001 0 0 0-1.309-1.515l-1.026.89a1.005 1.005 0 0 1-1.357-.039c-2.228-2.206-3.277-5.27-2.879-8.404.571-4.492 4.253-8.12 8.756-8.624 2.896-.33 5.673.555 7.823 2.478a10.01 10.01 0 0 1 2.82 10.64.999.999 0 1 0 1.896.635 12.016 12.016 0 0 0-3.384-12.765zm2.95 18.605A1.558 1.558 0 0 1 21.598 24h-9.198a1.558 1.558 0 0 1-1.346-2.343l4.6-7.884a1.558 1.558 0 0 1 2.691 0zM18 22a1 1 0 1 0-2 0 1 1 0 0 0 2 0m0-5a1 1 0 0 0-2 0v2a1 1 0 0 0 2 0z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-limit-speedometer_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLimitSpeedometer;
